"use strict";
window.initialProductSearch = function () {
  $("#q_applications_id_in").niceSelect();
  $("#q_functions_id_in").niceSelect();
  $("#q_principal_id_eq").niceSelect();
  $(".alert-notification").fadeTo(8000, 500).fadeOut("slow");

  $("#product_search").on("change", function () {
    var form = document.getElementById("product_search");
    Rails.fire(form, "submit");
  });
};
$(document).on("ready turbolinks:load", function () {
  initialProductSearch();
});
